import React from 'react';
import {
    Dialog, DialogTitle, DialogContent, Typography, Box, Button
} from '@mui/material';
import SuccessImg from '../../img-offer/successImgIcon.png';
import HourglassEmptyOutlinedIcon from '@mui/icons-material/HourglassEmptyOutlined';
import Timeline from '../../img-offer/timeline.svg'
import Timeline1 from '../../img-offer/timeline1.svg'
import Timeline2 from '../../img-offer/timeline2.svg'
import ReusableButton from '../../components/reusableComponents/reusableButtonComponents';
import ReusableMuiIcons from '../../_helpers/ReusableMuiIcons';

export default function OfferSuccessModal({ open , onClose}) {
    return (
        <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth sx={{
            '& .MuiDialog-paper': {
                width: '550px',
                borderRadius: '12px',
            }
        }}>
            <DialogTitle sx={{ p: 3 }}>
                <Box display="flex" justifyContent="center" mb={1}>
                    <img src={SuccessImg} style={{ width: '100px', height: '85px' }} alt="Success" />
                </Box>
                <Typography variant="h6" align="center" sx={{ fontSize: '20px', fontWeight: 500, color: '#000000' }}>Offer Created Successfully</Typography>
                <Box display="flex" justifyContent="center" alignItems="center" mt={1} sx={{ gap: 1 }}>
                    <img src={Timeline} />
                    <Typography sx={{ fontSize: '14px', color: '#D97706' }}>Pending Verification</Typography>
                </Box>
            </DialogTitle>

            <DialogContent>
                <Box bgcolor="#F0FDF4" borderRadius={'12px'} p={2} mb={2} sx={{ border: " 1px solid #DAFBE5" }}>
                    <Typography fontSize="14px" color='#219653'>
                        It is now pending verification by the GrooveNexus team.
                        Once your offer is reviewed and approved, it will go live
                        and appear in your Offers Dashboard.
                    </Typography>
                </Box>

                <Box bgcolor="#EFF6FF" borderRadius={1} p={1.5} mb={2} sx={{ border: "1px solid #BFDBFE" }}>

                    <Typography fontSize="14px" color='#1E40AF' display={'flex'} gap={1}>
                        <img src={Timeline1} />  Verification typically takes up to 24 hours
                    </Typography>
                </Box>

                <Box bgcolor="#F9FAFB" borderRadius={1} p={1.5} mb={3} sx={{ border: "1px solid #E5E7EB" }}>
                    <Typography fontSize={"16px"} color="#454545" display={'flex'} gap={1}><img src={Timeline2} /> Additional Notes:</Typography>
                    <Typography fontSize="14px" color='#7A7A7A'>
                        • You'll be notified once your offer is approved<br />
                        • Until then, the offer will remain locked and non-editable<br />
                        • Check your email for verification updates
                    </Typography>
                </Box>

                <Box display="flex" justifyContent={'center'}>
                    <ReusableButton children={'GO TO OFFER DASHBOARD'} variant="outlined" classNames={'gn-actionbtn-outline gn-actionbtn-color me-3'} onClick={onClose} sx={{ padding: '6px 70px 5px 70px' }} endIcon={<ReusableMuiIcons name='right' />} />
                </Box>
            </DialogContent>
        </Dialog>
    );
}
